import { DirectoryEntityType } from "../Api/medfar-contactdirectory/dist";
import { FaxDirectorySearchComponent } from "./Search/FaxDirectorySearchComponent";
import { FaxDirectorySearchResultItem } from "./Search/FaxDirectorySearchResultItem";

interface IDirectoryProfessionalSearchLockingComponent {
    componentId: string;
    disabled?: boolean;
    searchText: string;
    onTextChange: (text: string) => void;
    onItemSelected: (item: FaxDirectorySearchResultItem) => void;
    dataCy: string;
    selectedItems: { Name: string }[]
    onRemoveItem: (index: number) => void;
    placeholder?: string;

    /**
     * The max text length that can be entered into the search box, or null for unlimited.
     */
    maxLength?: number;
}

function DirectoryProfessionalSearchLockingComponent(props: IDirectoryProfessionalSearchLockingComponent): JSX.Element {
    if (props.selectedItems.any())
        return (
            <ul className="selected-items-list">
                {props.selectedItems.map((p, idx) => (
                    <li onClick={e => e.stopPropagation()} key={`${props.componentId}-${idx}`}>
                        <span className="content-text">{p.Name}</span>
                        <span className="remove-btn" onClick={() => props.onRemoveItem(idx)} />
                    </li>
                ))}
            </ul>
        );
    return (
        <FaxDirectorySearchComponent
            disableSearchField={props.disabled}
            entityTypes={[DirectoryEntityType.HealthcareProvider]}
            onItemSelected={item => props.onItemSelected(item)}
            searchText={props.searchText}
            onSearchTextChanged={text => props.onTextChange(text)}
            isValid
            disableEdit
            dataCy={props.dataCy}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
        />
    );
}

export { DirectoryProfessionalSearchLockingComponent };
